import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthentifiedPage from "./AuthentifiedPage";
import CollecteSuccessMessage from "../components/CollecteSuccessMessage";
import CollecteErrorMessage from "../components/CollecteErrorMessage";
import AddDocumentMenuWrapper from "../components/AddDocumentMenuWrapper";
import "../styles/ListFormAdmin.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Domaine, SousDomaine, SousSousDomaine } from "../types/Domaine";

export interface FormItem {
  id: string;
  title: string;
  description?: string;
  status: "draft" | "published";
}

const initialForms: FormItem[] = [
  { id: "f1", title: "Formulaire Personnes", description: "Collecte des informations personnelles", status: "published" },
  { id: "f2", title: "Formulaire Agriculture", description: "Collecte des rendements", status: "draft" },
];

const ListFormAdmin: React.FC = () => {
  const [forms, setForms] = useState<FormItem[]>(initialForms);
  const navigate = useNavigate();
  const [successVisible, setSuccessVisible] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonClicked, setButtonClicked] = useState<"createForm" | null>(null);

  const handleCreateForm = (domain?: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    setShowMenu(false);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/admin/dynamic-form", { state: { domain, sousDomain, sousSousDomain } });
    }, 500);
  };

  const handleCreateIndicator = (domain: Domaine, sousDomain?: SousDomaine, sousSousDomain?: SousSousDomaine) => {
    domain.icon = undefined;
    setShowMenu(false);
    setLoading(true);

    setTimeout(() => {
      setLoading(false);

      navigate("/create-indicateur", {
        state: {
          tableName: domain.tbl_name,
          sousDomain,
          sousSousDomain,
          mode: "createIndicator",
        },
      });
    }, 500);
  };
      const handleCreateRapport = (
      domain: Domaine,
      sousDomain?: SousDomaine,
      sousSousDomain?: SousSousDomaine
    ) => {
      domain.icon = undefined;
      setShowMenu(false);
      setLoading(true);
  
      setTimeout(() => {
        setLoading(false);
  
        navigate("/create-rapport", {
          state: {
            domain,
            sousDomain,
            sousSousDomain,
            mode: "createRapport",
          },
        });
      }, 500);
    };

  const handleDelete = (id: string) => {
    if (!window.confirm("Supprimer ce formulaire ?")) return;
    setForms(prev => prev.filter(f => f.id !== id));
    setSuccessMessage("Formulaire supprimé");
    setSuccessVisible(true);
    setTimeout(() => setSuccessVisible(false), 1500);
  };

  const handleEdit = (id: string) => {
    alert(`Modifier le formulaire ID: ${id}`);
    // Ici tu peux rediriger vers la page d'édition si besoin
    // navigate("/admin/edit-form/" + id);
  };

  return (
    <AuthentifiedPage>
      <main className="container py-4">
        <CollecteSuccessMessage visible={successVisible} message={successMessage} />
        <CollecteErrorMessage visible={errorVisible} message={errorMessage} />

        <div className="d-flex justify-content-between align-items-center">
            <h4 className="text-success fw-bold mb-0">Gestion des formulaires</h4>
              <button
                className="btn-add-offre"
                onClick={() => {
                  setButtonClicked("createForm");
                  setShowMenu(true);
                }}
              >
                <i className="bi bi-plus-lg"></i> Créer un formulaire
              </button>        
        </div>

        <div className="list-form-admin mt-4">

          {showMenu && (
            <AddDocumentMenuWrapper
              onSelect={() => {}}
              onCreateForm={handleCreateForm}
              onCreateIndicator={(handleCreateIndicator)}
              onCreateRapport={(handleCreateRapport)}
              onClose={() => setShowMenu(false)}
            />
          )}

          {loading && <div className="text-center mt-3">Chargement des données...</div>}

          <div className="table-responsive bg-white rounded shadow-sm p-3 mt-3">
            <table className="table table-hover mb-0">
              <thead>
                <tr>
                  <th>Titre</th>
                  <th>Description</th>
                  <th>Status</th>
                  <th style={{ width: 100 }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {forms.map(f => (
                  <tr key={f.id}>
                    <td>{f.title}</td>
                    <td>{f.description}</td>
                    <td>{f.status}</td>
                    <td className="text-center">
                      <button 
                        className="btn btn-sm btn-outline-success me-2"
                        onClick={() => handleEdit(f.id)}
                        title="Modifier"
                      >
                        <i className="bi bi-pencil"></i>
                      </button>
                      <button 
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(f.id)}
                        title="Supprimer"
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </td>
                  </tr>
                ))}
                {forms.length === 0 && (
                  <tr>
                    <td colSpan={4} className="text-center py-4">Aucun formulaire disponible</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>
    </AuthentifiedPage>
  );
};

export default ListFormAdmin;
